import _ from 'lodash';
import template from './equipmentLogs.html';


export default {
  name: 'equipmentLogs',
  template,
  controllerAs: 'EquipmentLogsCtrl',
  controller: EquipmentLogsController,
  bindings: {
    equipment: '<'
  }
};

/* @ngInject */
function EquipmentLogsController($q, $timeout, EquipmentNotificationsService) {
  const vm = this;

  vm.stopEquipmentLogsLoader = false;
  vm.disableInfiniteScroll = false;
  vm.logs = [];

  vm.$onChanges = onChanges;
  vm.getLogsForInfiniteScroll = getLogsForInfiniteScroll;
  vm.lengthOf = lengthOf;
  vm.vsRepeatOptions = {
    // `scrolledToEnd` now sends the scope into the function
    // We need to avoid this behaviour by wrapping `fetchEvents`
    scrolledToEnd: () => vm.getLogsForInfiniteScroll(),
    size: 250,
    autoresize: true,
    scrolledToEndOffset: 3,
  };

  function onChanges({ equipment = {} }) {
    const { currentValue, previousValue } = equipment;
    if (currentValue !== previousValue) {
      vm.logs = [];
      vm.disableInfiniteScroll = false;
      getLogsForInfiniteScroll();
    }
  }

  function getLogsForInfiniteScroll() {
    if (vm.disableInfiniteScroll) {
      return $q.reject();
    }

    vm.disableInfiniteScroll = true;

    // give the api a second to return the data before showing the spinner, to reduce the 'flashes'
    const loaderDelayTimeout = $timeout(() => {
      vm.stopEquipmentLogsLoader = false;
    }, 1000);

    const limit = 15;
    const filterDate =
        vm.logs.length > 0 ? new Date(vm.logs[vm.logs.length - 1].createdAt).valueOf() : Date.now();

    return EquipmentNotificationsService.getLogs(vm.equipment.id, limit, filterDate)
      .then((success) => {
        if (success.data.length > 0) {
          vm.logs.push(...success.data);
          if (success.data.length === limit) {
            vm.disableInfiniteScroll = false;
          }
        }
      })
      .finally(() => {
        $timeout.cancel(loaderDelayTimeout);
        vm.stopEquipmentLogsLoader = true;
      });
  }

  function lengthOf(obj) {
    return _.size(obj);
  }

}
